import { makeStyles } from '@material-ui/core/styles';
import { styleBreakMobile, styleBreakSmallMobile } from '../components/utilities/layouts/Globals';
import { COLOR_WHITE } from '../components/utilities/Material';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { ReactComponent as Logo } from '../resources/images/logo.svg';
import { ReactComponent as LogoWhite } from '../resources/images/logo-white.svg';

export const MobileNavBarStyle = makeStyles(theme => {
    /* Default styles */
    const styles = {
        list: {
            display: 'flex',
            flexDirection: 'column',
        },
        menuCard: {
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            width: theme.spacing(41),
            backgroundColor: theme.palette.primary.dark,
        },
        iconContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: theme.spacing(4),
            marginTop: theme.spacing(4),
            marginLeft: theme.spacing(5),
            marginRight: theme.spacing(5),
        },
        closeIcon: {
            cursor: 'pointer',
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
            fill: theme.palette.primary.contrastText,
        },
        toolBar: {
            display: 'flex',
            alignItems: 'center',
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
            position: 'relative',
        },
        menuIcon: {
            fill: theme.palette.primary.contrastText,
            cursor: 'pointer',
        },
        linkItem: {
            width: 'fit-content',
            marginRight: theme.spacing(0),
            paddingBottom: theme.spacing(0),
            textAlign: 'left',
        },
    };

    /* Add watchman specific styles */
    let watchmanStyles = {
        /* menuCard */
        menuCard: {
            backgroundColor: theme.palette.primary.main,
        },

        /* iconContainer */
        iconContainer: {
            marginTop: theme.spacing(1.5),
            marginRight: theme.spacing(3),
            display: 'flex',
            alignItems: 'center',
            paddingTop: theme.spacing(0),
        },

        /* closeIcon */
        closeIcon: { marginTop: theme.spacing(0), marginRight: theme.spacing(0) },

        /* toolBar */
        toolBar: {
            justifyContent: 'space-between',
            backgroundColor: COLOR_WHITE,
            [styleBreakSmallMobile(theme)]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
            [styleBreakMobile(theme)]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3),
                paddingTop: theme.spacing(2.5),
            },
        },

        navWithInfoToolBar: {
            [styleBreakMobile(theme)]: {
                paddingTop: theme.spacing(1.5),
            },
        },

        /* chatIcon */
        chatIcon: { cursor: 'pointer' },

        /* appBar */
        appBar: {
            boxShadow: '0px 1px 4px rgba(186, 186, 186, 0.25)',
        },

        /* custom text title instead of logo */
        headerTitle: {
            fontSize: theme.spacing(2.25),
            fontWeight: 600,
            color: theme.palette.primary.main,
            textTransform: 'uppercase',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },

        infoIcon: {
            color: theme.palette.primary.dark,
            margin: `0 ${theme.spacing(3) + 1}px`,
        },
    };
    // merge
    watchmanStyles = mergeStyles(cloneDeep(styles), watchmanStyles);

    /* Add Ned specific styles */
    let nedStyles = {
        /* toolbar */
        toolBar: { justifyContent: 'center', backgroundColor: theme.palette.primary.dark },

        /* menuIcon */
        menuIcon: {
            right: theme.spacing(3),
            top: '50%',
            transform: 'translateY(-50%)',
            position: 'absolute',
        },

        /* logoImage */
        logoImage: {
            width: '55px',
            height: '30px',
        },
    };
    // merge
    nedStyles = mergeStyles(cloneDeep(styles), nedStyles);

    const stylesMap = {
        ned: nedStyles,
        watchman: watchmanStyles,
    };

    return getStyle(stylesMap);
});

export const getActiveMobileLinkStyles = theme => {
    /* watchman specific */
    const watchmanActiveMobileLinkStyles = {
        color: theme.palette.primary.dark,
        borderBottom: `${theme.spacing(0.5)}px solid ${theme.palette.primary.dark}`,
    };

    /* Ned specific */
    const nedActiveMobileLinkStyles = {
        color: theme.palette.primary.light,
        borderBottom: `${theme.spacing(0.25)}px solid ${theme.palette.primary.light}`,
    };

    const activeMobileLinkStylesMap = {
        ned: nedActiveMobileLinkStyles,
        watchman: watchmanActiveMobileLinkStyles,
    };

    return getStyle(activeMobileLinkStylesMap);
};

export const { MobileMenuLogo } = getStyle({
    ned: { MobileMenuLogo: LogoWhite },
    watchman: { MobileMenuLogo: Logo },
});
